import React, { useRef } from 'react';
import clx from "classnames";
import { useState } from "react"
import { FiLayout, FiMenu, FiPhone,  FiSearch } from 'react-icons/fi'
import messengerStore from '../../../../stores/useMessenger'
import Send from './send';
import Search from '../../../shared/search';
import Conversations from './conversations';
import { Header } from './header';
import { Profile } from '../../../shared/profile';

export const Content = ({externalClass}) => {
    const [profile, setProfile] = useState(false);
    const [search, setSearch] = useState(false);
    const [phone, setPhone] = useState(false);
    const {detail, setDetail } = messengerStore(state=>state)
  
    const messages = messengerStore(state=>state.messages)
    const container = useRef(null);
  
    function useChatScroll(dep) {
      const ref = React.useRef();
      React.useEffect(() => {
        if (ref.current) {
          ref.current.scrollTop = ref.current.scrollHeight;
        }
      }, [dep]);
      return ref;
    }

    const setTheme = () => {
      let value = 'dark'
      document.body.setAttribute('data-mode', value)
      let scrollbar = document.querySelector('.scrollbar')
      if(value=='dark'){
          scrollbar.classList.add('dark')
      }else{
          scrollbar.classList.remove('dark')
      }
  }

    React.useEffect(()=>{
    /**
     Theme preferences
    */
     setTheme()

    },[])
  
    const ref = useChatScroll(messages)
    
    return(
      <div className={clx(detail?'md:col-span-6':'md:col-span-8', 
      `content bg-center bg-cover h-screen flex flex-col justify-between
      dark:bg-[#16191c] bg-gray-100 dark:text-white bg-[#fcfcfc]`,
       // 'content flex flex-col justify-between dark:bg-[#16191c] dark:text-white bg-[#fcfcfc]'
      )}>
        <div
          // :class="detail?'md:col-span-6':'md:col-span-8'"
          // style={{backgroundImage:'url("/images/wallpapers/2.jpg")'}}
          class="
          bg-center bg-contain
          dark:bg-[#16191c] dark:text-white bg-gray-100
          content h-screen flex flex-col justify-between "
        >
          <div
            ref={ref}
            class={clx(
              externalClass ? externalClass : 'h-screen',
              `relative conversation h-full overflow-y-auto overflow-x-hidden`
            )}
          >
           <Header
              search={search}
              setSearch={setSearch}
              phone={phone}
              setPhone={setPhone}
              detail={detail}
              setDetail={setDetail}
              profile={profile}
              setProfile={setProfile}
           />

            {!profile && !search && <Conversations /> }

            {profile &&  <Profile profile={profile} /> }

            {search && <Search /> }
  
            {!profile && <Send /> }
  
          </div>
        </div>
    
      </div>
    )
  }
